/**
 * @file AssignModal.jsx
 * @description AssignModal component for displaying and managing assign modal.
 * @component AssignModal
 * @exports AssignModal - Main component for displaying and managing assign modal.
 */

import React, { useEffect } from "react";
import {
  Typography,
  Button,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  TextField,
} from "@mui/material";
import { TYPOGRAPHY_VARIANT,STRINGS, VARIANTS, SIZES, BUTTON_COLORS } from "../../../common/constants/commonConstants.js";
import { TEXT_MESSAGE, TEXT_STRING } from "../../../common/constants/agentModule/textConstants.js";

const AssignModal = ({ open, customerId, users, onClose, onAssign, assignedCust }) => {
  const [assignedUser, setAssignedUser] = React.useState(null);
  const [assignedMe, setAssignedMe] = React.useState(false);
  const [validationError, setValidationError] = React.useState("");
  const currentUserEmail = JSON.parse(localStorage.getItem("user"));
  const agentemail = currentUserEmail?.emailaddress || "";

  useEffect(() => {
    if(agentemail && assignedCust === agentemail) {
      setAssignedMe(true);
      setAssignedUser(null);
    }else
    setAssignedUser(assignedCust);
  }, [open, assignedCust, agentemail]);

  const handleAssign = async () => {
    const assignUser = assignedMe ? agentemail : assignedUser;
    if (!assignUser && !assignedMe) {
      setValidationError(
        TEXT_MESSAGE.ASSIGN_USER_VALIDATION_MESSAGE
      );
      return;
    }
    onAssign(customerId, assignUser);
  };

  const handleAssignMe = (event) => {
    setAssignedMe(event.target.checked);
    setAssignedUser(null);
    setValidationError("");
  };
  return (
    <div>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            width: 400,
            margin: "auto",
            padding: 3,
            marginTop: 8,
            backgroundColor: "white",
            borderRadius: 2,
          }}
        >
          <Typography variant={TYPOGRAPHY_VARIANT.H6}>{TEXT_STRING.ASSIGN_USER_DAILOG_HEADER}</Typography>

          <FormControlLabel
            control={
              <Checkbox checked={assignedMe} onChange={handleAssignMe} />
            }
            label={TEXT_STRING.ASSIGN_ME}
          />
          <Autocomplete
            disabled={assignedMe}
            disablePortal
            size={SIZES.SMALL}
            options={users}
            value={
              assignedUser
                ? users.find((u) => u.emailaddress === assignedUser) || null
                : null
            }
            onChange={(event, newValue) => {
              setAssignedUser(newValue?.emailaddress || null);
              setValidationError("");
            }}
            getOptionLabel={(option) =>
              option ? `${option.firstname} ${option.lastname}` : ""
            }
            sx={{ pb: 2 }}
            renderInput={(params) => <TextField {...params} label="User" />}
          />
          {validationError && (
            <Typography variant={VARIANTS.CAPTION} gutterBottom sx={{ display: 'block', mb: 2, color: 'red'  }} >
              {validationError}
            </Typography>
          )}
          <Button
            variant={VARIANTS.CONTAINED}
            color={BUTTON_COLORS.PRIMARY}
            onClick={handleAssign}
            sx={{ mr: 1 }}
          >
            {TEXT_STRING.ASSIGN_USER}
          </Button>
          <Button variant={VARIANTS.OUTLINED} onClick={onClose}>
            {STRINGS.CANCEL}
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default AssignModal;
